<template>
  <div class="main">
    <div class="nav">
      <div class="navContainer">
        <p>类型：</p>
        <el-input v-model="searchParams.typeName" size="mini" style="width:150px" placeholder="请输入类型"/>
      </div>
      <div class="navContainer">
        <p>备注：</p>
        <el-input v-model="searchParams.bz" size="mini" style="width:150px" placeholder="请输入备注"/>
      </div>
      <div class="navContainer" style="width: 300px;">
        <p>创建时间：</p>
        <el-date-picker
          v-model="searchParams.time"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="navContainer">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="tableContainer">
      <div>
        <el-table :data="tableData" @row-click="onclickRow" border stripe size="mini" v-loading="loading">
          <el-table-column label="序号" width="50" align="center">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="signByName" label="签收人姓名" show-overflow-tooltip/>
          <el-table-column prop="typeName" label="类型" show-overflow-tooltip/>
          <el-table-column prop="msgContent" label="消息内容" show-overflow-tooltip>
            <template slot-scope='scope'>{{ scope.row.type == 1 ? scope.row.msgContent: '请点击查看更多' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip/>
          <el-table-column prop="bz" label="备注" show-overflow-tooltip/>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="通知内容" :visible.sync="dialogVisible" :fullscreen="isFullScreen">
      <div>
        <span style="font-weight: bold;">【超期未对账】</span>
      </div>
      <el-table :data="tableData1" style="margin-bottom: 20px;">
        <el-table-column label="超过3个月" header-align="center">
          <el-table-column prop="conventionalVehicle" label="委托商常规车">
            <template slot-scope="scope">
              <div v-html="scope.row.conventionalVehicle" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="resourceVehicle" label="委托商资源车" >
            <template slot-scope="scope">
              <div v-html="scope.row.resourceVehicle" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseYard" label="委托商库场及其他" >
            <template slot-scope="scope">
              <div v-html="scope.row.warehouseYard" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="waterway" label="供应商水路" >
            <template slot-scope="scope">
              <div v-html="scope.row.waterway" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="highway" label="供应商公路" >
            <template slot-scope="scope">
              <div v-html="scope.row.highway" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="supperPort" label="供应商港口" >
            <template slot-scope="scope">
              <div v-html="scope.row.supperPort" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="supperWarehouseYard" label="供应商库场及其他" >
            <template slot-scope="scope">
              <div v-html="scope.row.supperWarehouseYard" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table :data="tableData2" style="margin-bottom: 20px;">
        <el-table-column label="超过6个月" header-align="center">
          <el-table-column prop="conventionalVehicle" label="委托商常规车">
            <template slot-scope="scope">
              <div v-html="scope.row.conventionalVehicle" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="resourceVehicle" label="委托商资源车" >
            <template slot-scope="scope">
              <div v-html="scope.row.resourceVehicle" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseYard" label="委托商库场及其他" >
            <template slot-scope="scope">
              <div v-html="scope.row.warehouseYard" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="waterway" label="供应商水路" >
            <template slot-scope="scope">
              <div v-html="scope.row.waterway" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="highway" label="供应商公路" >
            <template slot-scope="scope">
              <div v-html="scope.row.highway" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="supperPort" label="供应商港口" >
            <template slot-scope="scope">
              <div v-html="scope.row.supperPort" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="supperWarehouseYard" label="供应商库场及其他" >
            <template slot-scope="scope">
              <div v-html="scope.row.supperWarehouseYard" style="white-space: pre-wrap;"></div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div>
        <span style="font-weight: bold;">【新增单位】</span>
      </div>
      <el-table :data="tableData3">
        <el-table-column prop="customerInfo" label="委托商">
          <template slot-scope="scope">
            <div v-html="scope.row.customerInfo"></div>
          </template>
        </el-table-column>
        <el-table-column prop="highwaySupplierInfo" label="水路供应商">
          <template slot-scope="scope">
            <div v-html="scope.row.highwaySupplierInfo"></div>
          </template>
        </el-table-column>
        <el-table-column prop="waterSupplierInfo" label="公路供应商">
          <template slot-scope="scope">
            <div v-html="scope.row.waterSupplierInfo"></div>
          </template>
        </el-table-column>
        <el-table-column prop="supplierPortOtherInfo" label="港口及其他供应商">
          <template slot-scope="scope">
            <div v-html="scope.row.supplierPortOtherInfo"></div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { messageList } from '@/service/message';
export default {
  components: {
  },

  data() {
    return {
      isFullScreen: true,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      dialogVisible: false,
      searchParams: {
        typeName: '',
        bz: '',
        time: '',
      },
      typeOption:[
        {value: 1,label: '计划消息'},
        {value: 2,label: '系统消息'},
        {value: 3,label: '签收消息'},
      ],
      degreeOption:[
        {value: 1,label: '一级'},
        {value: 2,label: '二级'},
        {value: 3,label: '三级'},
      ],
      tableData:[],
      loading: false,
      page:1,
      size:10,
      total:0,
    };
  },
  methods: {
    onclickRow(row) {
      if (row.type == 2) {
        const dataObj = JSON.parse(row.msgContent);
        this.tableData1 = Object.keys(dataObj['超期三个月']).length>0 ? [dataObj['超期三个月']] : [];
        this.tableData2 = Object.keys(dataObj['超期六个月']).length>0 ? [dataObj['超期六个月']] : [];
        this.tableData3 = Object.keys(dataObj['新增单位']).length>0 ? [dataObj['新增单位']] : [];
        this.dialogVisible = true;
      }
    },
    resetBtn(){
      this.searchParams.typeName = '';
      this.searchParams.bz = '';
      this.searchParams.time = '';
    },
    async getListData() {
      const res = await messageList({page: this.page, rows: this.size, ...this.searchParams});
      console.log(res);
      if (res.status !== 0) return this.$message.error(res.message);
      
      this.tableData = res.data.records;
      this.total = res.data.total;
    },
    searchBtn(){
      this.page = 1;
      this.getListData();
    },
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
  },
};
</script>



<style lang="scss" scoped>
.main{
  white-space: pre-wrap;
  height: calc(100vh - 60px);
  overflow-y: auto;
  width:100%;
  padding:22px 31px ;
  flex: 1;
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .tableContainer{
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    .paginationContainer{
      display: flex;
      align-items: center;
      margin: 20px 0;
      span{
        color:#101010;
        font-size: 13px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
</style>
